import { ItemService } from '@shared/service/items.service';
import { takeUntil, map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ShoppingCartLineModel } from '@core/model/shoppingCartLine.model';
import { environment } from '@env/environment';
import { AvailableModel } from '@core/model/availableClass.model';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { captureRejections } from 'events';
import { ModelsService } from '@shared/service/models.service';
import { DataMessageModel } from '@core/model/dataMessage.model';
import { MatDialog } from '@angular/material/dialog';
import { ModalErrorComponent } from '@shared/modal/modal-error/modal-error.component';
import { ModalSuccessComponent } from '@shared/modal/modal-success/modal-success.component';
import { Listener } from 'selenium-webdriver';
import { NgbTimeStructAdapter } from '@ng-bootstrap/ng-bootstrap/timepicker/ngb-time-adapter';
import { formatDate, getLocaleDateFormat } from '@angular/common';
import { debuglog } from 'util';
import { CommonService } from '@shared/service/common.service';
import { ModelInfo } from '@core/model/modelInfo.model';

export class ShoppingCartModel {
    Id: number;
    UserId: number;
    CustAccount: string;
    ProjectId: string;
    Currency: string;
    SiteId: string;
    IsActived: boolean;
    SumQty: number;
    SumGrossAmount: number;
    SumNetAmount: number;
    SumDiscountAmount: number;
    SumExpenseAmount: number;
    SumTaxAmount: number;
    HandleInventoryId: number;
    HandleDescription: string;
    DeliveryPostalAddress: string;
    InventSiteDelivery: string;
    AddressListId: string;
    DlvModeId: string;
    Detail: string;
    Shipping: boolean;
    DiscCuponAmount: number;
    ShoppingCartLabel: string;
    Confirmed: boolean;
    CreatedDateTime: Date;
    ExpirationDate: Date;
    QuotLabel: string;
    PurchOrder: string;
    ShoppingCartLines: ShoppingCartLineModel[];
    UpdateLine: boolean;
    ActuaPrecio: boolean;
    ReqReabastecimiento: boolean;
    AddressInfo: any[];
    CuponList: any[];
    UpdConfigSiteLine: boolean;

    constructor(_user, _custAccount, _project, _addressId, _siteId, _currency) {
        this.Id = 0;
        this.UserId = _user;
        this.CustAccount = _custAccount;
        this.ProjectId = _project;
        this.Currency = _currency;
        this.SiteId = _siteId;
        this.IsActived = true;
        this.SumQty = 0;
        this.SumGrossAmount = 0;
        this.SumNetAmount = 0;
        this.SumDiscountAmount = 0;
        this.SumExpenseAmount = 0;
        this.SumTaxAmount = 0;
        this.HandleInventoryId = 0;
        this.HandleDescription = '';
        this.DeliveryPostalAddress = '';
        this.InventSiteDelivery = '';
        this.AddressListId = _addressId;
        this.DlvModeId = '';
        this.Detail = '';
        this.Shipping = false;
        this.DiscCuponAmount = 0;
        this.ShoppingCartLabel = '';
        this.Confirmed = false;
        this.CreatedDateTime = new Date();
        this.ExpirationDate = new Date();
        this.QuotLabel = '';
        this.PurchOrder = '';
        this.ShoppingCartLines = [];
        this.UpdateLine = false;
        this.ActuaPrecio = false;
        this.ReqReabastecimiento = false;
        this.AddressInfo = [];
        this.CuponList = [];
        this.UpdConfigSiteLine = false;
    }

    async insertarLinea(_itemService: ItemService, _line: ShoppingCartLineModel, _dialog: MatDialog, _common: CommonService, _showMsjs: boolean = true, _validateAvail: boolean = true) {
      let responseValidate;
      let availableClass;
      let model;
      let cantAct:number = 0;
      let saveCart;
      let notMsj = false;
      let allowReq = true;
      if (!_line.ConfiguratedProduct) {
        saveCart = await this.cargarInfo(_itemService, _dialog, _common).then()
          saveCart.ShoppingCartLines.forEach(cartLines => {
            if(cartLines.Item[0].ItemId === _line.Item[0].ItemId
            && cartLines.Item[0].Color === _line.Item[0].Color
            && cartLines.Item[0].Style === _line.Item[0].Style
            && cartLines.Item[0].Size === _line.Item[0].Size
            && cartLines.Item[0].Config === _line.Item[0].Config)
            {
              cantAct = cartLines.Quantity;
            }
          });
      }

      this.ShoppingCartLines.push(_line);
      this.UpdateLine = true;
      _line.ActionId = 1;
      model = {
        ItemId: _line.Item[0].ItemId,
        ColorId: _line.Item[0].Color,
        StyleId: _line.Item[0].Style,
        SizeId: _line.Item[0].Size,
        ConfigId: _line.Item[0].Config,
        Qty: (+_line.Quantity + cantAct),
        SiteId: this.SiteId,
        ConfigProduct: _line.ConfiguratedProduct
      }

      if(_validateAvail) {
        responseValidate = await this.validarExistencias(_itemService, model).then()
        availableClass = responseValidate[0];
        if (availableClass.QtyEntregaInmediata < availableClass.QtyRequerida) {
          if(_showMsjs) {
            notMsj = true;
            let unsubscribe$ = new Subject<void>();
            let message = new DataMessageModel();
            message.icon = 'info-icon';
            message.status = 'error';
            message.QtyCarrito = cantAct;
            message.QtyDias = availableClass.QtyDias;
            message.QtyDisponible = availableClass.QtyDisponible;
            message.QtyDisponibleReabastece = availableClass.QtyDisponibleReabastece;
            message.QtyEntregaInmediata = availableClass.QtyEntregaInmediata;
            message.QtyRequerida = availableClass.QtyRequerida;
            message.IsKitItem = availableClass.isKitItem;
            message.textDescription = 'Tabla';
            const dialogRef = _dialog.open(ModalErrorComponent, {
              data: message,
              panelClass: ['alert-information-modal'],
              minWidth: '42vw', maxWidth: '90vw', maxHeight: '100vh', minHeight: '71vh'
            });
            await dialogRef.componentInstance.retValue
            .pipe(map(async result => {
              allowReq = result;
              if ((availableClass.QtyDisponible - cantAct) > 0 && allowReq) {
                _line.Quantity = availableClass.QtyDisponible - cantAct;
                await this.guardarCarrito(_itemService).then()
                  await _common.setUpdateShoppingCart(true);
                  await _common.setUpdateRedirectCart(true);

                  let dataMessageModel = new DataMessageModel();
                  let data: any = dataMessageModel;
                  dataMessageModel.labelTitile = 'Producto agregado exitosamente al carrito';
                  const dialogRef = _dialog.open(ModalSuccessComponent, {
                    data,
                    minWidth: '42vw', maxWidth: '90vw', maxHeight: '90vh', minHeight: '23vh'
                  });
                  dialogRef.afterClosed().subscribe(() => {
                    dialogRef.addPanelClass('ocultar-modal');
                    setTimeout(() => {
                      _dialog.closeAll();
                    }, 300);
                  });
              }
            })).toPromise()
          } else {
            if (availableClass.QtyDias > 0 && (availableClass.QtyDisponible >= availableClass.QtyRequerida) && allowReq) {
              await this.guardarCarrito(_itemService).then()
                await _common.setUpdateShoppingCart(true);
                await _common.setUpdateRedirectCart(true);
            }
          }
        } else {
          await this.guardarCarrito(_itemService).then()
            await _common.setUpdateShoppingCart(true);
            await _common.setUpdateRedirectCart(true);
        }
      } else {
        await this.guardarCarrito(_itemService).then()
          await _common.setUpdateShoppingCart(true);
          if(!_line.ConfiguratedProduct)
            await _common.setUpdateRedirectCart(true);
      }

      if(cantAct > 0 && _showMsjs) {
        let message = new DataMessageModel();
        message.icon = 'info-icon';
        message.status = 'error';
        message.labelTitile = 'Aviso';
        message.textDescription = 'El artículo solicitado ya ha sido previamente agregado a este carrito, no olvide verificar su cantidad total';
        const dialogRef = _dialog.open(ModalErrorComponent, {
          data: message,
          panelClass: ['alert-information-modal'],
          minWidth: '42vw', maxWidth: '90vw', maxHeight: '90vh', minHeight: '23vh'
        });
      } else if(_showMsjs && !notMsj) {
        let dataMessageModel = new DataMessageModel();
        let data: any = dataMessageModel;
        dataMessageModel.labelTitile = 'Producto agregado exitosamente al carrito';
        const dialogRef = _dialog.open(ModalSuccessComponent, {
          data,
          minWidth: '42vw', maxWidth: '90vw', maxHeight: '90vh', minHeight: '23vh'
        });
        dialogRef.afterClosed().subscribe(() => {
          dialogRef.addPanelClass('ocultar-modal');
          setTimeout(() => {
            _dialog.closeAll();
          }, 300);
        });
      }
    }

    async actualizarLinea(_itemService: ItemService, _modelsService: ModelsService, _line: ShoppingCartLineModel, dialog: MatDialog, validaInv, _common: CommonService) {
      let responseValidate;
      let availableClass;
      let LineTmp: ShoppingCartLineModel;
      let model
      let i = 0;
      let Line: ShoppingCartLineModel;

      for(i=0; i<= this.ShoppingCartLines.length -1; i++) {
        Line = this.ShoppingCartLines[i];
        if(Line.Id === _line.Id) {
          this.UpdateLine = true;
          LineTmp = _line;
          LineTmp.ActionId = 2;
          model = {
            ItemId: _line.Item[0].ItemId,
            ColorId: _line.Item[0].Color,
            StyleId: _line.Item[0].Style,
            SizeId: _line.Item[0].Size,
            ConfigId: _line.Item[0].Config,
            Qty: _line.Quantity,
            SiteId: this.SiteId,
            ConfiguratedProduct: _line.ConfiguratedProduct,
            TipoProd: _line.TipoProduccion
          }

          if(model.TipoProd === null) {
            model.TipoProd = 0;
          }

          if(_line.ConfiguratedProduct) {
            if(_line.Model === null) {
              let modelTmp: ModelInfo = new ModelInfo();
              Line.Model = await _modelsService.getModelInformation(_line.Id);
            }
            else {
              Line.Model = _line.Model;
            }
            Line.Model.vCantidad = _line.Quantity;
            Line.DetalleLinea = _line.DetalleLinea;
            Line.Quantity = _line.Quantity;
            Line.ActionId = _line.ActionId;
            Line.PriceUnit = _line.PriceUnit;
            Line.Item[0].Style = model.StyleId;
            Line.Item[0].Color = model.ColorId;
            Line.Item[0].Size = model.SizeId;
            Line.Item[0].Config = model.ConfigId;
          }
        }
      }

      if(validaInv) {
        if(_line.ConfiguratedProduct) {
            await this.guardarCarrito(_itemService).then()
              await _common.setUpdateShoppingCartLines(true);
        } else {
          responseValidate = await this.validarExistencias(_itemService, model).then()
          if(responseValidate) {
            availableClass = responseValidate[0];
            if (availableClass.QtyEntregaInmediata < availableClass.QtyRequerida) {
              let message = new DataMessageModel();
              let unsubscribe$ = new Subject<void>();
              message.icon = 'info-icon';
              message.status = 'error';
              message.QtyDias = availableClass.QtyDias;
              message.QtyDisponible = availableClass.QtyDisponible;
              message.QtyDisponibleReabastece = availableClass.QtyDisponibleReabastece;
              message.QtyEntregaInmediata = availableClass.QtyEntregaInmediata;
              message.QtyRequerida = availableClass.QtyRequerida;
              message.QtyRequerida = availableClass.QtyRequerida;
              message.IsKitItem = availableClass.isKitItem;
              message.textDescription = 'Tabla';
              message.UpdateOption = true;
              const dialogRef = await dialog.open(ModalErrorComponent, {
                data: message,
                panelClass: ['alert-information-modal'],
                minWidth: '42vw', maxWidth: '90vw', maxHeight: '100vh', minHeight: '71vh'
              })

              return await dialogRef.componentInstance.retValue
              .pipe(map(async result => {
                if ((availableClass.isKitItem || availableClass.QtyDisponible > 0) && result) {
                  if (availableClass.QtyDisponible < availableClass.QtyRequerida) {
                    _line.Quantity = availableClass.QtyDisponible;
                  }
                  await this.guardarCarrito(_itemService).then()
                    await _common.setUpdateShoppingCartLines(true);
                } else {
                  await _common.setUpdateShoppingCartLines(true);
                }
              })).toPromise();
            } else {
              await this.guardarCarrito(_itemService).then()
                await _common.setUpdateShoppingCartLines(true);
            }
          }
        }
      } else {
        await this.guardarCarrito(_itemService).then()
          await _common.setUpdateShoppingCartLines(true);
      }
    }

    async validarExistencias(_itemService: ItemService, model) {
      return await _itemService.validateInventAvailable(model);
    }

    async eliminarLinea(_itemService: ItemService, _line: ShoppingCartLineModel, dialog: MatDialog, _common: CommonService) {
      this.ShoppingCartLines.forEach(Line => {
        if(Line.Id === _line.Id) {
          this.UpdateLine = true;
          Line = _line;
          Line.ActionId = 3;
        }
      });
      await this.guardarCarrito(_itemService).then()
      return await this.cargarInfo(_itemService, dialog, _common);
    }

    async guardarCarrito(_itemService: ItemService) {
      return await _itemService.guardarCarrito(this);
    }

    async cargarInfo(_itemService: ItemService, dialog: MatDialog, common: CommonService) {
      let carrito = new ShoppingCartModel(this.UserId, this.CustAccount, this.ProjectId, this.AddressListId, this.SiteId, this.Currency);
      let today = new Date(await common.getBDCurrentDate().then())
        carrito = Object.assign(carrito, await _itemService.GetShoppingCartModel(this).then())
        if(today > new Date(carrito.ExpirationDate) && carrito.ShoppingCartLines.length > 0) {
          carrito.ActuaPrecio = true;
          await carrito.guardarCarrito(_itemService).then()
          carrito = await _itemService.GetShoppingCartModel(carrito).then()
          let data = new DataMessageModel();
          data.labelTitile = 'El carrito actual ha vencido. Se realizó una actualización del precio de sus líneas';
          const dialogRef = dialog.open(ModalSuccessComponent, {
            data,
            minWidth: '42vw', maxWidth: '90vw', maxHeight: '90vh', minHeight: '23vh', disableClose: true});
            dialogRef.afterClosed();
        }

        if(carrito.UpdConfigSiteLine && carrito.ShoppingCartLines.length > 0) {
          await carrito.guardarCarrito(_itemService).then()
          carrito = await _itemService.GetShoppingCartModel(carrito).then()
        }
        return carrito;
    }
}
